<div class="dialog-title">
  <span>Feedback</span>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<div matDialogContent>
  <form [formGroup]="feedbackGroup">
    <mat-form-field appearance="outline">
      <mat-label>Feedback Type</mat-label>
      <mat-select formControlName="type">
        <mat-option value="Feedback">Feedback</mat-option>
        <mat-option value="Bug">Bug</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" >
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description"
        cdkTextareaAutosize cdkAutosizeMaxRows="5" cdkAutosizeMinRows="5"></textarea>
    </mat-form-field>
  </form>

</div>


<div matDialogActions class="dialog-actions">
  <button mat-flat-button color="primary" (click)="submitFeedback()">Submit Feedback</button>
</div>
